module.exports = __webpack_public_path__ + "static/media/消息.8f38477d.svg";